<template>
    <div class="content">
        <div class="header flex-row">
            <div class="step-item flex-column">
                <img src="../../assets/img/icon-info.svg" />
                填写预约信息
            </div>
            <div class="step-item flex-column" style="color: #fff">
                <img src="../../assets/img/icon-ordered.svg" />
                确认订单信息
            </div>
            <div class="step-item flex-column">
                <img src="../../assets/img/icon-settlement.svg" />
                订单预约待审核
            </div>
        </div>
        <div class="section">
            <div class="tag flex-row">
                <div class="flex-column">
                    <img src="../../assets/img/btzs-icon.png" />
                    <span>确认参观信息</span>
                </div>
            </div>
            <div class="date">
                <span>{{ param.teamType == 1 ? "导游姓名" : "领队人员" }}</span
                >：{{ param.name }}
            </div>
            <div class="date"><span>参观人数</span>：{{ param.userCount || 0 }}人</div>
            <!-- <div class="table">
                <div class="tableHeader flex-row">
                    <div class="item">姓名</div>
                    <div class="item">身份证号码</div>
                    <div class="item">联系电话</div>
                    <div class="item">门票名称</div>
                </div>
                <div class="tBody">
                    <div class="th flex-row" v-for="(item, index) in param.personList" :key="index">
                        <div class="data">
                            {{ item.customerName }}
                        </div>
                        <div class="data">
                            {{ item.customerIdCard }}
                        </div>
                        <div class="data">
                            {{ item.customerPhone }}
                        </div>
                        <div class="data">
                            {{ item.productName }}
                        </div>
                    </div>
                </div>
            </div> -->
            <div class="date">参观日期：{{ param.currentDate }}</div>
            <div class="tag flex-row">
                <div class="flex-column">
                    <img src="../../assets/img/btzs-icon.png" />
                    <span>温馨提示</span>
                </div>
            </div>
            <div class="detail">
                <div class="item flex-row">
                    <img src="../../assets/img/icon-tip1.png" />
                    团队需至少提前三天在四川大学博物馆官网或微信公众号预约购票，到团当日无法预约当天票。
                </div>
                <div class="item flex-row">
                    <img src="../../assets/img/icon-tip1.png" />
                    参观日请联系人提前组织好团队，按照二维码下方的进场时间从团队入口有序扫码进场，超过预约时间30分钟，二维码失效，无法入场。
                </div>
                <div class="item flex-row">
                    <img src="../../assets/img/icon-tip1.png" />
                    开馆时间:09:00，停止入馆时间:16:30，闭馆时间:17:00。
                </div>
                <div class="item flex-row">
                    <img src="../../assets/img/icon-tip1.png" />
                    咨询电话028-85412543，028-85400772。
                </div>
            </div>
            <img class="line" src="../../assets/img/icon-line.svg" />
            <div class="btnbox flex-row">
                <div class="backbtn cursorp" @click="toPage">返回上一步</div>
                <!-- <router-link to="ReservationReview"> -->
                <div class="prevbtn cursorp" @click="CreateOrder">确认订单提交</div>
                <!-- </router-link> -->
            </div>
        </div>
    </div>
</template>

<script>
import { createOrder, merchantNo, getTeamAttestationDetail } from "../../utils/http.js";
import Api from "@/utils/common.js"; //公共方法
import tool from "@/utils/tools";
export default {
    name: "TeamConfirmOrder",
    data() {
        return {
            param: {},
            list: [],
            content: {},
        };
    },
    mounted() {
        // 保存上一页传递过来的参数
        this.param = this.$route.params;
        let uid = tool.getStore("uid");
        // 获取审核详情
        this.getTeamAttestationDetail({
            uid: uid,
        });
    },
    methods: {
        // 获取审核详情
        getTeamAttestationDetail(param) {
            getTeamAttestationDetail(param).then(res => {
                if (res.code == 0) {
                    this.content = res.data;
                }
            });
        },
        // 创建订单
        CreateOrder() {
            let data = [
                {
                    teamType: this.param.teamType, //团队类型0:学校
                    // ...this.content,
                    applicationFileUrl: this.content.businessLicenseUrl, // 保存的是学校介绍信字段
                    idCardFileUrl: this.param.idCardFileUrl, // 身份证正面
                    reverseIdCardFileUrl: this.param.reverseIdCardFileUrl, // 身份证反面
                    businessLicense: this.content.permitOperation, // 保存的是统一信用代码证字段
                    creditCode: this.content.creditCode,
                    teamName: this.content.teamName,
                    merchantNo: merchantNo, //商户号
                    isExplanationServiceConsultation: 0, //讲解服务，0:无
                    contact: this.param.name, //经办人姓名
                    contactNumber: this.param.phone, //经办人联系电话
                    notes: this.param.remark, //备注
                    application_file_url: this.param.application_file_url, //介绍信、电子行程单
                    instructionsProveFileUrl: this.param.instructionsProveFileUrl,

                    // instructions_prove_fileUrl: this.param.instructions_prove_fileUrl, //导游证
                    teamAppointmentItemParamList: [
                        {
                            planDay: this.param.currentDate, //参观日期
                            timeSlotId: this.param.currentTime, //参观时段id
                            visitorInformationFileUrl: this.param.filePath, //参观人员名单地址
                            userCount: this.param.userCount,
                            // userCount: this.param.personList.length,
                        },
                    ],
                },
            ];
            console.log("data", data, this.content);
            let params = {
                data: JSON.stringify(data),
                customerIdCard: this.param.Idcard,
                customerIdCardType: 0, //证件类型
                orderType: 1, //团队预约
                sourceType: 2, //订单来源官网
                payType: 0, //支付方式 现金
            };
            // 数据加密
            let encryptionStr = Api.encryptBASE64(JSON.stringify(params));
            // 加密签名
            let autographStr = Api.autograph(encryptionStr);
            let param = {
                sign: autographStr,
                signData: encryptionStr,
            };
            createOrder(param).then(res => {
                this.$router.push({
                    path: "ReservationReview",
                    query: {
                        orderNo: res.orderSn,
                    },
                });
                // console.log('创建成功', res)
            });
        },
        // 返回上一步
        toPage() {
            this.$router.back();
        },
    },
};
</script>

<style scoped>
.content {
    width: 1200px;
    margin: auto;
    background: #fff;
    background-size: 100%;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
    border-radius: 6px;
    padding: 24px;
    box-sizing: border-box;
}

.header {
    width: 100%;
    height: 70px;
    background-image: url(../../assets/img/step2.svg);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding: 0 130px;
    box-sizing: border-box;
    justify-content: space-between;
    margin-bottom: 24px;
}

.header .step-item {
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #bb2916;
}

.header .step-item img {
    width: 26px;
    height: 26px;
    margin-bottom: 6px;
}

.header .step-item img:first-child {
    width: 30px;
    height: 24px;
}

.header .step-item img:last-child {
    width: 26px;
    height: 24px;
}

.section {
    width: 100%;
}

.section .table {
    width: 1007px;
    padding: 0 60px;
    box-sizing: border-box;
}

.table .tableHeader {
    width: 1007px;
    height: 64px;
    border-radius: 6px 6px 0px 0px;
    background-image: url("../../assets/img/tableBG.svg");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    justify-content: space-between;
}

.table .tableHeader .item {
    font-size: 16px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    width: 167px;
    text-align: center;
}

.table .tBody {
    width: 1007px;
    max-height: 500px;
    border: 1px solid #f1f1f1;
    background: #ffffff;
    overflow-y: scroll;
}

.table .tBody .th {
    width: 100%;
    height: 63px;
    background: #ffffff;
    justify-content: space-between;
    border-bottom: 1px solid #f1f1f1;
}

.table .tBody .th:last-child {
    border: none !important;
}

.tBody .th .data {
    font-size: 16px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    width: 167px;
    text-align: center;
}

.section .date {
    margin-top: 16px;
    margin-bottom: 24px;
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 600;
    color: #bb2916;
    margin-left: 60px;
}

.section .detail {
    margin: 24px 0;
    margin-left: 60px;
}

.detail .item {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #333;
    margin-bottom: 20px;
}

.detail .item img {
    width: 14px;
    height: 14px;
    margin-right: 4px;
}

.line {
    width: 1038px;
    height: 6px;
    margin: 24px 0;
    margin-left: 60px;
}

.btnbox {
    justify-content: center;
}

.btnbox div {
    width: 324px;
    height: 60px;
    font-size: 22px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    text-align: center;
    line-height: 60px;
    border-radius: 30px;
}

.btnbox .backbtn {
    color: #bb2916;
    background: #ffffff;
    border: 1px solid #bb2916;
    margin-right: 32px;
    cursor: pointer;
}

.btnbox .prevbtn {
    color: #ffffff;
    background: #bb2916;
    cursor: pointer;
}

/deep/ .el-radio {
    display: flex;
    flex-direction: row;
    align-items: center;
}

/deep/.el-radio .el-radio__label {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: #000000;
}

/deep/ .el-radio__inner {
    width: 20px;
    height: 20px;
    background: #f3f3f3;
    border: 2px solid #bb2916;
}

/deep/ .el-radio__input.is-checked .el-radio__inner {
    border-color: #bb2916;
    background: #bb2916;
}

/deep/.el-radio__input.is-checked + .el-radio__label {
    color: #000000;
}
</style>
